module.exports = __webpack_public_path__ + "img/dept-1.1fa0f33c.svg";